var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-content"},[_c('query-frame',{attrs:{"pageVisible":false,"searchVisible":false,"addVisible":false}},[_c('template',{slot:"table"},[_c('i-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataList}})],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }